module.exports = new __parcel__URL__("particles.8d1cc640.glb").toString();